import React, { useState } from 'react';
import { Play, Pause, Heart, Music, Search, X, Disc, Sparkles } from 'lucide-react';

const MusicList = ({ musicData = [], playTrack, saved = [], setSaved, currentTrackId, isPlaying }) => {
  const [query, setQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  // Filter logic for the search bar
  const filtered = musicData.filter(t => 
    t.title.toLowerCase().includes(query.toLowerCase()) || 
    t.artist.toLowerCase().includes(query.toLowerCase())
  );

  // Toggle favorite function (Fixes the setSaved is not a function error)
  const toggleFav = (track) => {
    setSaved(prev => {
      const isAlreadySaved = prev.find(p => p.id === track.id);
      if (isAlreadySaved) {
        return prev.filter(p => p.id !== track.id);
      } else {
        return [...prev, track];
      }
    });
  };

  const clearSearch = () => {
    setQuery("");
    setIsFocused(false);
  };

  return (
    <div className="fade-in">
      {/* --- HEADER --- */}
      <div style={{ marginBottom: '25px', padding: '0 5px' }}>
        <div className="badge" style={{ background: 'var(--accent-soft)', color: 'var(--accent)', marginBottom: '10px' }}>
          <Sparkles size={14} /> <span>{musicData.length} Tracks Available</span>
        </div>
        <h1 style={{ fontSize: '32px', fontWeight: '800', letterSpacing: '-1px' }}>
          Discover <span>Music</span>
        </h1>
      </div>

      {/* --- BEAUTIFUL SEARCH BAR --- */}
      <div className="search-wrapper" style={{ position: 'sticky', top: '80px', zIndex: '100' }}>
        <div className="search-box">
          <Search size={20} color={isFocused ? "var(--accent)" : "var(--text-dim)"} />
          <input 
            className="search-input"
            placeholder="Search by title or artist..." 
            value={query}
            onFocus={() => setIsFocused(true)}
            onChange={(e) => setQuery(e.target.value)}
          />
          {query && <X size={18} onClick={() => setQuery("")} style={{ cursor: 'pointer' }} />}
        </div>
         
      </div>

      {/* --- MUSIC STACK --- */}
      <div className="music-stack" style={{ marginTop: '20px' }}>
        {filtered.length > 0 ? (
          filtered.map((track) => {
            const isFav = saved.some(s => s.id === track.id);
            const isCurrent = currentTrackId === track.id;

            return (
              <div 
                key={track.id} 
                className={`track-card ${isCurrent ? 'active-card' : ''}`}
              >
                <div className="track-left" style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1 }}>
                  <div className="art-wrapper" style={{ 
                    width: '54px', height: '54px', background: 'var(--bg-subtle)', 
                    borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' 
                  }}>
                    {isCurrent && isPlaying ? (
                      <Disc size={22} className="spin" color="var(--accent)" />
                    ) : (
                      <Music size={20} color="var(--text-dim)" />
                    )}
                  </div>
                  <div className="track-meta">
                    <div style={{ fontWeight: '700', fontSize: '16px', color: 'var(--text-main)' }}>
                      {track.title}
                    </div>
                    <div style={{ fontSize: '13px', color: 'var(--text-dim)', fontWeight: '500' }}>
                      {track.artist}
                    </div>
                  </div>
                </div>

                <div className="track-actions" style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                  <Heart 
                    size={22} 
                    onClick={() => toggleFav(track)} 
                    fill={isFav ? "var(--accent)" : "none"} 
                    color={isFav ? "var(--accent)" : "#cbd5e1"} 
                    style={{ cursor: 'pointer', transition: '0.3s transform' }} 
                    className={isFav ? "heart-pop" : ""}
                  />
                  <button 
                    onClick={() => playTrack(track)} 
                    style={{ 
                      border: 'none', background: 'var(--accent-grad)', 
                      width: '46px', height: '46px', borderRadius: '50%', 
                      color: 'white', display: 'flex', alignItems: 'center', 
                      justifyContent: 'center', cursor: 'pointer',
                      boxShadow: '0 8px 15px rgba(16, 185, 129, 0.2)'
                    }}
                  >
                    {isCurrent && isPlaying ? (
                      <Pause size={20} fill="white" />
                    ) : (
                      <Play size={20} fill="white" style={{ marginLeft: '2px' }} />
                    )}
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ textAlign: 'center', padding: '60px 20px', opacity: 0.5 }}>
            <Search size={40} style={{ marginBottom: '10px' }} />
            <p>No results found for "{query}"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MusicList;